import { connect } from 'react-redux';
import { getRepairResourcesAction } from '../actions';
import { RepairResourceLookupComponent } from '../components/RepairResourceLookupComponent';
import { getResourceLookupResources, getResourceLookupIsFetchResourcesFailure, getResourceLookupIsFetchResourcesSuccess, getResourceLookupIsResourcesLoading } from '../selectors';
const mapStateToProps = (state) => {
    return {
        resourcesData: getResourceLookupResources(state),
        isResourceFailure: getResourceLookupIsFetchResourcesFailure(state),
        isResourcesLoading: getResourceLookupIsResourcesLoading(state),
        isResourcesLoadingSuccess: getResourceLookupIsFetchResourcesSuccess(state)
    };
};
const mapDispatchToProps = (dispatch) => ({
    getRepairResourceInfo: (repairResourcePayload) => {
        dispatch(getRepairResourcesAction(repairResourcePayload, true));
    }
});
export const ConnectedRepairResourceLookup = connect(mapStateToProps, mapDispatchToProps)(RepairResourceLookupComponent);
//# sourceMappingURL=ConnectedRepairResourceLookup.js.map